<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListProdutos";

export default {
  data() {
    return {
      subjectPermission: "Produtos",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
